/* eslint-disable */
import React, { useState } from 'react';
import { Box } from '@mui/material';
import { SRGroup } from './SRGroup';
import type { SRGroup as SRGroupType } from '../../utils/grouping';

interface SRGroupedListProps {
  groups: SRGroupType[];
}

export const SRGroupedList: React.FC<SRGroupedListProps> = ({ groups }) => {
  // Track which groups are expanded (initialize from groups' isExpanded property)
  const [expandedGroups, setExpandedGroups] = useState<Set<string>>(() => {
    return new Set(groups.filter((g) => g.isExpanded).map((g) => g.groupKey));
  });

  const handleToggle = (groupKey: string) => {
    setExpandedGroups((prev) => {
      const next = new Set(prev);
      if (next.has(groupKey)) {
        next.delete(groupKey);
      } else {
        next.add(groupKey);
      }
      return next;
    });
  };

  return (
    <Box>
      {groups.map((group) => (
        <SRGroup
          key={group.groupKey}
          groupKey={group.groupKey}
          groupLabel={group.groupLabel}
          items={group.items}
          isExpanded={expandedGroups.has(group.groupKey)}
          onToggle={() => handleToggle(group.groupKey)}
        />
      ))}
    </Box>
  );
};
